"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApplyInfoById = void 0;
var request_1 = require("../utils/request");
/**
 * 根据投递id获取投递详情
 * @param apply_id 投递的id
 */
var getApplyInfoById = function (apply_id) {
    return request_1.request({
        url: "/company/apply/resume/v1/info",
        params: { apply_id: apply_id, without_resume: true, without_template: true },
    });
};
exports.getApplyInfoById = getApplyInfoById;
